/**
 * 根据特定规则格式化时间
 * 0~60秒（1分钟以内）：刚刚
 * 1分钟~59分钟：X分钟前
 * 1小时~23小时：X小时前
 * 24小时~48小时（昨天）：昨天 HH:mm
 * 48小时~72小时（前天）：前天 HH:mm
 * 超过3天，但不超过当前年份：MM-DD HH:mm
 * 跨年：YYYY-MM-DD
 * @param {String|Date|Number} time 待格式化的时间
 * @returns {String} 格式化后的字符串
 */
export function formatTimeByRule(time) {
	if (!time) return '';
	const date = new Date(time);
	if (isNaN(date.getTime())) return time;

	const now = new Date();
	const diff = (now.getTime() - date.getTime()) / 1000; // 秒

	const pad = (val) => String(val).padStart(2, '0');
	const HH = pad(date.getHours());
	const mm = pad(date.getMinutes());
	const MM = pad(date.getMonth() + 1);
	const DD = pad(date.getDate());
	const YYYY = date.getFullYear();

	// 刚刚
	if (diff < 60) {
		return '刚刚';
	}

	// X分钟前
	if (diff < 3600) {
		return Math.floor(diff / 60) + '分钟前';
	}

	// X小时前
	if (diff < 86400) {
		return Math.floor(diff / 3600) + '小时前';
	}

	// 昨天/前天/超过3天 逻辑需要基于自然日判断
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const targetDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const dayDiff = Math.floor((today.getTime() - targetDay.getTime()) / 86400000);

	if (dayDiff === 1) {
		return `昨天 ${HH}:${mm}`;
	}
	if (dayDiff === 2) {
		return `前天 ${HH}:${mm}`;
	}

	// 超过3天，但不超过当前年份
	if (YYYY === now.getFullYear()) {
		return `${MM}-${DD}`;
	}

	// 跨年
	return `${YYYY}-${MM}-${DD}`;
}

/**
 * 格式化时间为 yyyy-MM-dd HH:mm 格式
 * @param {String|Date|Number} time 待格式化的时间
 * @returns {String} 格式化后的字符串
 */
export function formatDateTime(time) {
	if (!time) return '';
	const date = new Date(time);
	if (isNaN(date.getTime())) return time;

	const pad = (val) => String(val).padStart(2, '0');
	const YYYY = date.getFullYear();
	const MM = pad(date.getMonth() + 1);
	const DD = pad(date.getDate());
	const HH = pad(date.getHours());
	const mm = pad(date.getMinutes());

	return `${YYYY}-${MM}-${DD} ${HH}:${mm}`;
}